module.exports = __webpack_public_path__ + "img/dices-top.84c4a00c.svg";